module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon1.1a669bfe.png";